export default {"src":"/_next/static/image/public/images/flags/flag_253.a746c9d022352645cd6785281a4f0f82.svg","height":16,"width":24};